<template>
    <div class="cta-image-area_one section-space--pb_120">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="cta-image cta-image-bg">
                        <div class="row align-items-center">
                            <div class="col-lg-8">
                                <div class="cta-image__content my-5">
                                    <h4 class="cta-image__title text-white mb-5 wow move-up">Need more than that?</h4>
                                    <div class="cta-image__text text-white mb-3 wow move-up">Let's talk to a deal that meets your business need with the best assistance for growth.</div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <!-- <div class="cta-image__media wow move-up"> -->
                                <div class="wow move-up text-center">
                                    <!-- <b-nav-item href="#contactus" class="btn btn--green scroll">
                                        Contact us now
                                    </b-nav-item> -->
                                    <a href="mailto:support@quicksend.asia" class="btn btn--green scroll">
                                        Contact us now
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CtaOne',
    }
</script>

<style>
    .nav-item.btn.btn--green a {
        padding: 0 ;
    }
    .nav-item.btn.btn--green a:hover {
        color: inherit;
    }
</style>